"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const videoStyles_1 = require("../../../styling/videoStyles");
const styles_1 = tslib_1.__importDefault(require("./styles"));
const ButtonText = (0, react_1.forwardRef)(({ active, buttonText = "", children, classes = {}, classNames = "", disabled = false, label = "Default Button", onClick, style = {}, id, activeId, inActiveId, ...props }, ref) => {
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "button-text");
    let loweredLabel;
    if (typeof label !== "undefined") {
        loweredLabel = label.replace(/\s+/g, "-").toLowerCase();
    }
    return (react_1.default.createElement("button", { title: label, "aria-label": label, className: `${mergedClasses.root} ${active || ""} ${classNames && classNames}`, "data-selenium": `${label && loweredLabel}-button`, disabled: disabled, onClick: onClick, ref: ref, style: style, type: "button", id: id, "data-active-state-id": active ? activeId : inActiveId, ...props }, children));
});
ButtonText.displayName = "ButtonText";
exports.default = ButtonText;
//# sourceMappingURL=index.js.map